import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IFetchUserConsentsResult } from "./types";
import { serverResponse } from "./validators";

export async function fetchUserConsents(): Promise<IFetchUserConsentsResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/consents`,
    {
      validator: serverResponse,
    }
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(result.value);
}
